module.exports = __webpack_public_path__ + "img/task_install_mission.32569a3c.svg";